import comp from "./OrganizationModal.js";
export default comp;
